import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import OverlineHeading from "../OverlineHeading/OverlineHeading";

import "./card-group.scss";

const CardGroup = ({ children, inline, heading, headingIcon, className, ...props }) => {
  const classes = classNames(
    "card-group",
    {
      "card-group--inline": inline,
    },
    className
  );

  return (
    <div className={classes} {...props}>
      {heading && (
        <OverlineHeading
          text={heading}
          icon={headingIcon}
          size="large"
          className="card-group__heading"
        />
      )}
      {children}
    </div>
  );
};

CardGroup.propTypes = {
  inline: PropTypes.bool,
  heading: PropTypes.string,
  headingIcon: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.node)]),
  className: PropTypes.string,
};

export default CardGroup;
